module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CHAPTER 1")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_c('em', [_vm._v("What Happens When Local Politics Win?")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("This chapter recounts how the financial affairs of a major municipality can be controlled and impaired by the financial interests of the rich and powerful.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("n early December 1978, my client, John Carhuff, the head of public finance at First Boston, retained me to travel with him to Cleveland. I was to counsel First Boston in preparing Cleveland’s mayor to negotiate for renewal of fourteen million dollars’ worth of notes held by the local banks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While Cleveland was then considered a city with declining business and population like Buffalo, the small amount of the required renewal seemed easily achievable. However, on the plane going there, John explained that, in representing Mayor Dennis Kucinich, we would be representing a person who was considered an outsider with a small loyal supporting staff. Knowing more was at stake than only note renewal, I sensed we were in for a tough negotiating battle.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("By way of background, the private utility, Cleveland Electric Utility Company (CEUC), had allegedly been violating antitrust rules numerous times.")]), _c('span', {
    attrs: {
      "href": "#/031_Endnotes#note_1",
      "id": "note-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Specifically, it had been attempting to put the public utility, Municipal Light, out of business. Over time, Municipal Light had accrued fourteen million dollars in debt, which Mayor Kucinich’s predecessor had sought to settle by selling Municipal Light to CEUC. This would resolve the debt and thus settle the antitrust suit.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("When Mayor Kucinich was elected, he reversed course, seeking other means to pay off that debt while proceeding with the antitrust suit against CEUC.")]), _c('span', {
    attrs: {
      "href": "#/031_Endnotes#note_2",
      "id": "note-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" The mayor was adamant and outspoken to the effect that the antitrust case was a separate matter with a solid claim for substantial damages, so he was unwilling to engage in any settlement talks linked to the small amount of renewal of the notes.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Efforts Stymied")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("However, Mayor Kucinich’s efforts were stymied by Ohio’s largest bank (whose ownership was, I was informed, entangled with CEUC) and by Cleveland’s city council. In those years, it could be assumed with good reason that the powerful and rich families in Cleveland were owners of stock in CEUC. In those days, the IOUs (investor-owned utilities) were regulated with reasonably attractive rates of return and considered safe and prudent investments, so every family trust would have included a substantial holding of this IOU stock. However, the city’s antitrust case seriously challenged its safety as an investment. That’s why members of the city council, led by the filibuster of its speaker under control of his constituents—the rich and powerful citizens and their trusts—were holding up the authorization for note renewal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I went to Cleveland in early December facing this political environment. In the first meeting with the banks, I was impressed by the vast amount of rich mahogany in the conference room and hallways. Cleveland had been home to major corporations, and the splendor of the downtown offices spoke volumes about the wealth "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("that once made Cleveland among the richest cities in the nation. I was representing Buffalo as well at the time, and Cleveland clearly had the benefit of many more corporate headquarters and centers of industrial power than Buffalo.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Next, I noted that the traditional bond counsel firms were not represented in the room due to conflicts of interest with various clients. In particular, Squire Dempsey, the leading bond counsel firm, found itself squarely on both sides, having represented the city in the past as its bond counsel and as counsel to CEUC, the investor-owned utility. This IOU was in door-to-door competition with the city-owned municipal light company against which the city had filed a treble damage antitrust case.")]), _c('span', {
    attrs: {
      "href": "#/031_Endnotes#note_3",
      "id": "note-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("John Carhuff of First Boston made it clear to the banks that Cleveland’s fiscal problems extended well beyond the note renewal. He said the city should successfully renew its notes and then the city and city council could address resolving the lawsuit. Therefore, be advised that they should get the note deal done and then resolve all the other issues as part of an overall restructuring plan. On December 14th, I spent the evening negotiating this approach with the bankers at the same time as the mayor and his staff were working city council members to pass the renewal resolution.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('strong', [_vm._v("Refused to Yield the Floor")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The city council’s spokesperson, George Forbes, held the floor from approximately ten p.m. until well past midnight. He refused to yield it to present the renewal resolution for introduction and voting. As a result, at midnight, the relatively small number of notes went into default. As the largest municipal default in history since the depression, it became headline news throughout the nation."), _c('span', {
    attrs: {
      "href": "#/031_Endnotes#note_4",
      "id": "note-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" It is unclear for how long Cleveland paid a penalty in its tax-exempt interest rate, but clearly it paid something. For instance, some blue sky laws prevent buying bonds of a defaulted issuer for a period of five years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Then what? Mayor Kucinich was defeated at the next election. His successor not only dropped the case but went on to become governor. However, to Mayor Kucinich’s credit, the press and citizenry recognized that he had been absolutely correct in his position regarding the interests of the taxpayers. In 1997, Kucinich was elected to the U.S. House of Representatives and was regularly reelected through 2013. He was twice a candidate for U.S. president and ran for governor in Ohio.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What’s the takeaway from this Cleveland default? That despite the mayor’s leadership and astute understanding of the validity and value of the antitrust claims, vested financial interests allowed the city to default on its indebtedness. This resulted in increased interest costs to city taxpayers and the budget loss of the enormous benefit of an achievable award in the antitrust case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("However, this local political power of private interests over public interests was “small time” compared to the political power that was persuasive in a national agenda to protect (think “scam”) the special interest of investor-owned utilities that operated nuclear facilities. Those investor-owned facilities convinced legislatures in several states to deregulate the power production part of the utility business and issue taxable so-called rate reduction bonds to absorb the stranded costs of those power facilities. These terms and the “deregulation mania” that swept the country is described in the next chapter.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b89738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Chapter01.vue
// module id = 75
// module chunks = 0